export const TARGET_TYPES = {
    BLANK: '_blank',
    SELF: '_self',
    PARENT: '_parent',
    TOP: '_top'
};

export const TAKE_OPTIONS = {
    DEFAULT: 3,
    ALL: -1
};

export const DEBOUNCE_DELAY = 500;

export const DEFAULT_TIMEOUT = 5000;

export const CURRENCY = 'kr';

export const CARD_NUMBER_LENGTH = {
    NEW: 9,
    OLD: 16
};

export const NOTIFICATION_BAR_STATE_SUCCESS = {
    BG: 'bg-focused',
    BORDER: 'primary-light'
};

export const NOTIFICATION_BAR_STATE_ERROR = {
    BG: 'error-10',
    BORDER: 'error'
};

export const NOTIFICATION_BAR_STATE_WARNING = {
    BG: 'warning-10',
    BORDER: 'warning'
};

export const STORE_ID_TYPES = {
    TRAVEL_CARD: 'travel-card',
    ISSUE_DETAILS: 'issue-details',
    ISSUE_CARD: 'issue-card',
    ORDERS: 'orders'
};

export const PURCHASE_NOTIFICATION_VISIBILITY_VALUE = 1;
